import React from 'react';
import classnames from 'classnames';
import { Row, Col, Typography, Divider } from 'antd';
import { useTranslation } from 'react-i18next';
import NotAvailable from 'components/NotAvailable';
import {
  CompanyRow,
  CompanyCard,
  CompanyLink,
  CompanySubtitle1,
  CompanyRiskFactorTagging,
} from 'pages/private/KYBCompany/CompanyDetailsV2/components';
import PropTypes from 'prop-types';

const { Text } = Typography;

const I18N_BASE_PATH = 'pages.private.KYBCompany.pages';
const RISK = `${I18N_BASE_PATH}.companyDetails.subPages.companyInfo.businessIdentity.riskFactors`;
const RELEVANT = `${RISK}.relevant.api.risk`;
const STATUS = `${RISK}.status`;

const RiskFactors = ({ companyInfo }) => {
  const { t } = useTranslation();
  const risks = companyInfo?.businessIdentity?.risks || [];

  return (
    <CompanyCard className="kyb-company-summary-risk">
      <Row>
        <Col span={24}>
          <CompanySubtitle1>
            {t(`${RISK}.title`)} {!risks?.length ? '' : `(${risks.length})`}
          </CompanySubtitle1>
        </Col>
      </Row>
      {!risks?.length && <NotAvailable card />}
      {risks?.slice(0, 3).map((item) => (
        <>
          <CompanyRow className="kyb-company-summary-risk-content" justify="start">
            <Col span={24} className="kyb-company-summary-risk-inner">
              <CompanyRiskFactorTagging i18n={STATUS} value={item.value} />
              <Text className={classnames('typescale-body-2')}>
                {t(`${RELEVANT}.${item.name}`, '') || <NotAvailable />}
              </Text>
            </Col>
          </CompanyRow>
          <Row>
            <Col span={24}>
              <Divider className="no-mrg" />
            </Col>
          </Row>
        </>
      ))}
      <Row justify="end">
        <Col className="kyb-company-summary-footer">
          <CompanyLink to="?tab=financial">
            {t(`${I18N_BASE_PATH}.companyDetails.mainCardLink`)}
          </CompanyLink>
        </Col>
      </Row>
    </CompanyCard>
  );
};

RiskFactors.propTypes = {
  companyInfo: PropTypes.object.isRequired,
};

export default RiskFactors;
